import {
  FETCH_SCORES_STATS_START,
  FETCH_SCORES_STATS_SUCCESS,
  FETCH_SCORES_STATS_FAIL,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  scoresStats: null,
  isFetching: true,
  errorMessage: '',
}

const scoresStatsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SCORES_STATS_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      }
    case FETCH_SCORES_STATS_SUCCESS:
      return {
        ...state,
        scoresStats: action.payload,
        isFetching: false,
        errorMessage: '',
      }
    case FETCH_SCORES_STATS_FAIL:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default scoresStatsReducer
